export default class {
    constructor() {
        this.loading = false;
        this.loaded = false;
        this.locationData = false;
        this.locationDataIncludesAddress = false;
        this.locationDataIncludesPhone = false;
        // Array of Promise resolves waiting for the location data to resolve
        this.awaitingResolve = [];
        // If the preloadedLocationData variable exists on the window, use it instead of calling the API
        if (typeof window.preloadedLocationData !== 'undefined' && typeof window.preloadedLocationData.l !== 'undefined' && window.preloadedLocationData.l.length > 0) {
            this.locationData = preloadedLocationData.l;
            this.loaded = true;
            this.loading = false;
            this.locationDataLoaded();
        }
    }

    locationDataLoaded() {
        if (this.locationData === false) {
            console.error('LocationDataLoader was loaded but locationData was not set');
            return;
        }

        this.awaitingResolve.forEach(awaitingResolve => {
            awaitingResolve(this.locationData);
        });
    }

    /**
     * Get the location data from the R&D website API
     *
     * @param {Boolean} getAddressInfo
     * @param {Boolean} getPhoneInfo
     * @returns {Promise}
     */
    async get(getAddressInfo = false, getPhoneInfo = false) {
        return new Promise((resolve, reject) => {
            // If we're waiting for data to be returned from our website API, then push this promise resolution onto a stack of promise resolves to be called when the API responds
            if (this.loading == true) {
                this.awaitingResolve.push(locationData => {
                    resolve(locationData);
                });
                return;
            }

            if (this.loaded == true) {
                if (this.locationData === false) {
                    console.error('LocationDataLoader is loaded but locationData was not set');
                    reject();
                    return;
                }
                // Can't quickly think up the opposite for this if statement so just using else
                if ((this.locationDataIncludesAddress == false && getAddressInfo == true) || (this.locationDataIncludesPhone == false && getPhoneInfo == true)) {
                } else {
                    resolve(this.locationData);
                    return;
                }
            }

            this.loading = true;
            $.ajax({
                url: "/api/locations",
                type: "GET",
                data: {
                    includeAddresses : getAddressInfo ? 1 : 0,
                    includePhone : getPhoneInfo ? 1 : 0,
                },
                cache: true,
                dataType: "JSON",
                success: response => {
                    this.locationData = response;
                    this.loading = false;
                    this.loaded = true;
                    this.locationDataIncludesAddress = getAddressInfo;
                    this.locationDataIncludesPhone = getPhoneInfo;
                    this.loaded = true;
                    resolve(this.locationData);
                    this.locationDataLoaded();
                },
                error: function(error) {
                    this.loaded = false;
                    this.loading = false;
                    console.error('LocationDataLoader was unable to get location data from the API', error);
                    reject();
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/LocationDataLoader.js